import { render, staticRenderFns } from "./PackDetail.vue?vue&type=template&id=802f1d4c&scoped=true&"
import script from "./PackDetail.vue?vue&type=script&lang=js&"
export * from "./PackDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PackDetail.vue?vue&type=style&index=1&id=802f1d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802f1d4c",
  null
  
)

export default component.exports